import React, { useEffect, useState } from "react";
import { AiOutlineSearch } from "react-icons/ai";
import { BsFilter, BsTrash3 } from "react-icons/bs";
import SignatureModal from "../../../../components/SignatureModal";
import { RiAddFill } from "react-icons/ri";
import _ from "lodash";
import * as yup from "yup";
import { set, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { createSafeJobAnalysis } from "../../../../Services/safeJobAnalysisService";
import { Link, useParams } from "react-router-dom";
import {
  getProjectByIdService,
  getProjectByUserId,
} from "../../../../Services/projectService";
import { toast } from "react-toastify";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { t } from "../../../../utils/translate";
import { FaPencilAlt } from "react-icons/fa";
import { IoClose } from "react-icons/io5";
import RequiredPermitChecklist from "../../../../components/RequiredPermitChecklist";
import SafetyChecklist from "../../../../components/SafetyChecklist";
import DesignatedWorkChecklist from "../../../../components/DesignatedWorkChecklist";
import SignaturePersonModal from "../../../../components/SignaturePersonModal";
import MainLayout from "../../../components/layout/MainLayout";

const schema = yup.object().shape({
  projectDetail: yup.object().shape({
    safeJobAnalysisName: yup
      .string()
      .required(t("safeJobAnalysisNameIsRequired")),
    dateOfAnalysis: yup.string().required(t("dateOfAnalysisIsRequired")),
    workDescription: yup.string().required(t("workDescriptionIsRequired")),
  }),
  emergencyProcedure: yup.string(),
});

const styles = {
  color: "red",
};

const SafeJobAnalysisPage = () => {
  const adminId = useSelector((state) => state?.auth?.loggedInUser?._id);
  const [projectId, setProjectId] = useState(null);
  const [projects, setProjects] = useState([]);
  const [isProjectOpen, setIsProjectOpen] = useState(true);
  const currentLanguage = useSelector(
    (state) => state?.global?.current_language
  );
  const { accessLevel: roleOfUser } = useSelector((state) => state?.project);
  const navigate = useNavigate();
  const [isModalOpen, setModalOpen] = useState(false);
  const [isPersonModalOpen, setPersonModalOpen] = useState(false);
  const [isModalOpenone, setModalOpenone] = useState(false);
  const [isModalOpentwo, setModalOpentwo] = useState(false);
  const [signatureImage, setSignatureImage] = useState(null);
  const [signPersonImage, setSigPersonImage] = useState([]);
  const [signatureImageone, setSignatureImageone] = useState(null);
  const [divCount, setDivCount] = useState(1);
  const [customerName, setCustomerName] = useState("");
  const [customerPersonName, setCustomerPersonName] = useState("");
  const [personSignatures, setPersonSignatures] = useState([]);
  const [approverName, setApproverName] = useState("");
  const [projectDetail, setProjectDetail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [currentDate, setCurrentDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [addData, setAddData] = useState({
    name: "",
    signature: "",
  });
  const [scaffoldData, setScaffoldData] = useState([]);
  const [selectedSubTask, setSelectedSubTask] = useState("");
  const [selectedRisk, setSelectedRisk] = useState("");
  const [selectedMeasure, setSelectedMeasure] = useState("");
  const [data, setData] = useState(
    [...Array(divCount)].map(() => ({ risk: "", measure: "" }))
  );

  const defaultItems = [
    { checkListName: "sja_hard_hat", yes: false, na: false, no: false },
    {
      checkListName: "sja_safety_glassess",
      yes: false,
      na: false,
      no: false,
    },
    { checkListName: "sja_gloves", yes: false, na: false, no: false },
    { checkListName: "sja_safety_boots", yes: false, na: false, no: false },
    {
      checkListName: "sja_high_visibility_cloths",
      yes: false,
      na: false,
      no: false,
    },
    {
      checkListName: "sja_hearing_protection",
      yes: false,
      na: false,
      no: false,
    },
    { checkListName: "sja_dust_mask", yes: false, na: false, no: false },
    {
      checkListName: "sja_protection_harness",
      yes: false,
      na: false,
      no: false,
    },
  ];

  const defaultRequirePermit = [
    { checkListName: "sja_work_height", yes: false, no: false },
    { checkListName: "sja_confined_space", yes: false, no: false },
    { checkListName: "sja_hot_work", yes: false, no: false },
  ];

  const defaultDesignatedWorkArea = [
    { checkListName: "sja_cordon", yes: false, no: false },
    { checkListName: "sja_question_01", yes: false, no: false },
    {
      checkListName: "sja_question_02",
      yes: false,
      no: false,
    },
    {
      checkListName: "sja_question_03",
      yes: false,
      no: false,
    },
    {
      checkListName: "sja_question_04",
      yes: false,
      no: false,
    },
  ];

  const [items, setItems] = useState(defaultItems);
  const [requiredPermit, setRequiredPermit] = useState(defaultRequirePermit);
  const [designatedWorkArea, setDesignatedWorkArea] = useState(
    defaultDesignatedWorkArea
  );
  const [extendedList, setExtendedList] = useState(true);

  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [currentEditedId, setCurrentEditedId] = useState("");
  const [editedData, setEditedData] = useState("");
  const [editCreateTask, setEditCreateTask] = useState({
    risk: "",
    measure: "",
    riskLevel: "",
    measureLevel: "",
  });

  const {
    register,
    handleSubmit,
    reset,
    watch,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      projectDetail: {
        projectName: projectDetail?.projectName,
      },
    },
  });

  useEffect(() => {
    getProjectDetail();
  }, [projectId]);

  const handleDateChange = (event) => {
    setCurrentDate(event.target.value);
  };

  const handleAddSignature = () => {
    setModalOpen(true);
  };

  const handleAddPersonSignature = () => {
    setPersonModalOpen(true);
  };

  const handleAddSignatureone = () => {
    setModalOpenone(true);
  };

  const handleAddSignaturetwo = () => {
    setModalOpentwo(true);
  };

  const handleSaveSignature = (signatureDataUrl, name) => {
    setSignatureImage(signatureDataUrl, name);
    setCustomerName(name);
  };
  const signatureDate = new Date();
  const formattedDate = signatureDate.toLocaleDateString();
  const handlePersonSaveSignature = (signatureDataUrl, name) => {
    setSigPersonImage(signatureDataUrl, name);
    setCustomerPersonName(name);
    setPersonSignatures([
      ...personSignatures,
      { signatureDataUrl, name, date: formattedDate },
    ]);
  };
  const handleDeleteSignature = (name, index) => {
    const updatedPersonSignatures = [...personSignatures];
    if (index >= 0 && index < updatedPersonSignatures?.length) {
      updatedPersonSignatures.splice(index, 1);
      setPersonSignatures(updatedPersonSignatures);
    }
  };

  const handleSaveSignatureone = (signatureDataUrl, name) => {
    setSignatureImageone(signatureDataUrl, name);
    setApproverName(name);
  };

  const handleSaveSignaturetwo = async (signatureDataUrl) => {
    const uploadedSignURL = await handleUpload(signatureDataUrl);
    setAddData({ ...addData, signature: uploadedSignURL });
  };

  const closeModal = () => {
    setModalOpen(false);
    setPersonModalOpen(false);
  };

  const closeModalone = () => {
    setModalOpenone(false);
  };

  const closeModaltwo = () => {
    setModalOpentwo(false);
  };

  const [riskAssessment, setRiskAssessment] = useState({
    projectName: "",
    safeJobAnalysisName: "",
    dateOfAnalysis: "",
    jobTaskDescription: "",
    hazardsAndRisks: "",
    safetyMeasures: "",
    personalProtectiveEquipment: "",
    sequenceOfJobTask: "",
  });

  const [distributation, setDistributation] = useState({
    companyName: "",
    otherRelevantParties: "",
  });

  const onSubmit = async (data) => {
    setIsLoading(true);
    try {
      let signature = {
        customer: { name: customerName, signature: signatureImage },
        approver: { name: approverName, signature: signatureImageone },
      };
      if (personSignatures?.length > 0) {
        signature = {
          ...signature,
          person: personSignatures,
        };
      } else {
        toast.error(t("atLeastOnePersonSignatureIsRequired"));
        setIsLoading(false);
        return;
      }
      const payload = {
        ...data,
        scaffoldData: scaffoldData,
        signature,
        userId: projectDetail?.userId,
        projectNumber: projectDetail?.projectNumber,
        projectId,
        notificationToAdminCreate: roleOfUser === 0 ? false : true,
        protectiveEquipment: items,
        typeOfWork: requiredPermit,
        designatedWorkArea: designatedWorkArea,
        emergencyProcedure: data?.emergencyProcedure,
      };

      const response = await createSafeJobAnalysis(payload);
      if (response?.status === "success") {
        toast.success(t("safeJobAnalysisCreatedSuccessfully"));
        navigate(`/admin/sja`);
      } else {
        toast.error(t("failedToCreateSafeJobAnalysis"));
      }
    } catch (error) {
      return error;
    } finally {
      setIsLoading(false);
    }
  };

  const getProjectDetail = async () => {
    const response = await getProjectByIdService(projectId);
    setProjectDetail(response?.data?.project);
  };

  const [image, setImage] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const [searchTerm, setSearchTerm] = useState("");

  const filteredProjects = projects.filter((project) => {
    const searchLower = searchTerm.toLowerCase();
    const nameMatch = project.projectName.toLowerCase().includes(searchLower);
    const numberMatch = project.projectNumber.toString().includes(searchLower);
    return nameMatch || numberMatch;
  });

  const handleUpload = async (base64Image) => {
    setLoading(true);
    try {
      const file = base64Image;
      const formData = new FormData();
      formData.append("file", file);
      formData.append("upload_preset", "cyby2hpr");
      const folderName = "signature";
      const publicId = `users/${projectDetail?.userId}/${folderName}/${
        addData.name || `${projectDetail?.userId}_signature`
      }`;
      formData.append("public_id", publicId);
      const response = await axios.post(
        "https://api.cloudinary.com/v1_1/ddrvpin2u/image/upload",
        formData
      );
      setImage(response.data.url);
      return response?.data?.url;
    } catch (error) {
      setError(t("errorUploadingImagePleaseTryAgain"));
    } finally {
      setLoading(false);
    }
  };

  const handleSubtask = (e) => {
    setSelectedSubTask(e.target.value);
  };
  const handleRisk = (index, event, isRiskLevel) => {
    const newData = [...data];

    if (isRiskLevel) {
      newData[index].riskLevel = event.target.value;
    } else {
      newData[index].risk = event.target.value;
      setData(newData);
    }
  };

  const handleMeasure = (index, event, isMeasureLevel) => {
    const newData = [...data];
    if (isMeasureLevel) {
      newData[index].measureLevel = event.target.value;
      setData(newData);
    } else {
      newData[index].measure = event.target.value;
      setData(newData);
    }
  };

  const handleAddDiv = () => {
    setDivCount(divCount + 1);
    setData([
      ...data,
      { risk: "", measure: "", riskLevel: "", measureLevel: "" },
    ]);
  };
  const condition = data.every(
    (item) => item.risk !== "" && item.measure !== ""
  );
  const handleSave = () => {
    if (condition) {
      const newData = {
        id: scaffoldData?.length + 1,
        subtask: selectedSubTask,
        subtaskData: data,
      };

      setScaffoldData([...scaffoldData, newData]);
      setSelectedMeasure("");
      setSelectedSubTask("");
      setSelectedRisk("");
      setData([{ risk: "", measure: "" }]);
    } else {
      toast.error("Fill risk and measure");
      setData([{ risk: "", measure: "" }]);
    }
  };
  const handleDelete = (id) => {
    const updatedFormData = [...scaffoldData];
    const filteredData = updatedFormData?.filter((ele, ind) => ind !== id);
    setScaffoldData(filteredData);
  };

  const handleEdit = (id) => {
    const updatedFormData = [...scaffoldData];
    const filteredData = updatedFormData?.filter((ele, ind) => ind === id);
    setEditedData([...filteredData[0]?.subtaskData] || []);
    setCurrentEditedId(id);
    setShowConfirmationModal(true);
    // setScaffoldData(filteredData);
  };

  const [addSubtak, setSubTask] = useState(false);
  const handelAdd = () => {
    setSubTask(!addSubtak);
    setDivCount(1);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
    }
  };

  const handleEditTaskDelete = (id) => {
    const deleteData = [...editedData]?.filter((ele, ind) => ind !== id);
    setEditedData(deleteData);
  };

  const handleEditTask = () => {
    const addTaskToMainList = [...editedData, editCreateTask];
    setEditedData(addTaskToMainList);
    setEditCreateTask({
      risk: "",
      measure: "",
      riskLevel: "",
      measureLevel: "",
    });
  };

  const handleEditMainTask = () => {
    const newEditedData = [...editedData];
    setScaffoldData((prev) =>
      prev.map((ele, id) => {
        if (id === currentEditedId) {
          return { ...ele, subtaskData: newEditedData };
        } else {
          return ele;
        }
      })
    );
    setShowConfirmationModal(false);
  };

  const handleSelect = (e) => {
    setProjectId(e.target.value);
  };

  const handleConfirm = () => {
    if (projectId) {
      setIsProjectOpen(false);
    } else {
      toast.error("Please select a project.");
    }
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  const getProjectsDataByUserId = async (id) => {
    if (!id) return;

    setLoading(true);

    try {
      const responseData = await getProjectByUserId(id);
      if (responseData) {
        setProjects(responseData?.data);
      } else {
        setProjects([]);
      }
    } catch (err) {
      console.error("Error fetching projects:", err);
      setProjects([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (adminId) {
      getProjectsDataByUserId(adminId);
    }
  }, [adminId]);

  return (
    <MainLayout title={"Safe Job Analysis Form"}>
      <div className="md:pb-[50px] pb-6 border-b-[#cccccc] border-b">
        <div className="custom-container flex flex-col md:flex-row gap-[20px] justify-between ">
          <p className="title-text ">{t("safeJobAnalysis")}</p>
          <div className="flex gap-4">
            <div className="flex justify-center items-center gap-[1rem]">
              <div className="flex justify-between rounded-[5px] items-center gap-[30px] border border-[rgb(204, 204, 204)] px-[10px] py-[11px] bg-[white]">
                <p className="project-number leading-0 uppercase">
                  {t("projectName")}
                </p>
                <p className="medium-title leading-0 uppercase">
                  {projectDetail?.projectName || (
                    <div role="status">
                      <svg
                        aria-hidden="true"
                        class="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
                        viewBox="0 0 100 101"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                          fill="currentColor"
                        />
                        <path
                          d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                          fill="currentFill"
                        />
                      </svg>
                    </div>
                  )}
                </p>
              </div>
            </div>
            <div className="flex justify-center items-center gap-[1rem]">
              <div className="flex justify-between rounded-[5px] items-center gap-[30px] border border-[rgb(204, 204, 204)] px-[10px] py-[11px] bg-[white]">
                <p className="project-number leading-0 uppercase">
                  {t("projectNumber")}
                </p>
                <p className="medium-title leading-0">
                  {projectDetail?.projectNumber || (
                    <div role="status">
                      <svg
                        aria-hidden="true"
                        class="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
                        viewBox="0 0 100 101"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                          fill="currentColor"
                        />
                        <path
                          d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                          fill="currentFill"
                        />
                      </svg>
                    </div>
                  )}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="custom-container">
          <div className="flex flex-col gap-[30px]">
            <div className="flex justify-between items-center md:py-[50px] sm:py-8 py-4">
              <p className="medium-title text-center underline w-full">
                {t("safeJobAnalysis")}
              </p>
            </div>
          </div>

          <div className="flex justify-between sm:gap-8 gap-4 flex-wrap w-full">
            <div className="w-full lg:w-[calc(50%-20px)] flex flex-col justify-between gap-[6px]">
              <lable className="project-number w-full">
                {/* {t("dateOfAnalysis")} */}
                {t("safeJobAnalysisName")}
                <span style={{ color: "red", fontSize: "1.5em" }}>*</span>
              </lable>
              <div className="">
                <input
                  className="input-without-icon-1 h-[50px] fullWidth"
                  type="text"
                  placeholder={t("SafeJobAnalysisName")}
                  onChange={(e) =>
                    setRiskAssessment({
                      ...riskAssessment,
                      safeJobAnalysisName: e.target.value,
                    })
                  }
                  {...register("projectDetail.safeJobAnalysisName", {
                    required: true,
                  })}
                />
                {errors?.projectDetail?.safeJobAnalysisName && (
                  <span style={styles} className="mt-2 block">
                    {errors?.projectDetail?.safeJobAnalysisName?.message}
                  </span>
                )}
              </div>
            </div>
            <div className="w-full lg:w-[calc(50%-20px)] flex flex-col justify-between gap-[6px]">
              <lable className="project-number w-full">
                {t("dateOfAnalysis")}
                <span style={{ color: "red", fontSize: "1.5em" }}>*</span>
              </lable>
              <div className="">
                <input
                  className="input-without-icon-1 h-[50px] fullWidth"
                  type="date"
                  placeholder="Scaffold Identification/Number"
                  onChange={(e) =>
                    setRiskAssessment({
                      ...riskAssessment,
                      dateOfAnalysis: e.target.value,
                    })
                  }
                  {...register("projectDetail.dateOfAnalysis", {
                    required: true,
                  })}
                />
                {errors.projectDetail?.dateOfAnalysis && (
                  <span style={styles} className="mt-2 block">
                    {errors.projectDetail.dateOfAnalysis.message}
                  </span>
                )}
              </div>
            </div>
            <div className="w-full lg:w-[calc(50%-20px)] flex flex-col gap-[6px]">
              <lable className="project-number w-full">
                {/* {t("dateOfAnalysis")} */}
                {t("WorkDescription")}
                <span style={{ color: "red", fontSize: "1.5em" }}>*</span>
              </lable>
              <div className="">
                <textarea
                  className="w-full p-[20px] border rounded-[5px]"
                  type="text"
                  placeholder={t("WorkDescription")}
                  {...register("projectDetail.workDescription", {
                    required: true,
                  })}
                />
                {errors?.projectDetail?.workDescription && (
                  <span style={styles} className="mt-2 block">
                    {errors?.projectDetail?.workDescription?.message}
                  </span>
                )}
              </div>
            </div>
            <div className="w-full lg:w-[calc(50%-20px)] flex flex-col gap-[6px]">
              <label className="project-number w-full flex items-center justify-between">
                <div className="">
                  {t("responsibleWorkers")}
                  <span style={{ color: "red", fontSize: "1.5em" }}>*</span>
                </div>
                {personSignatures?.length > 0 && (
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      handleAddPersonSignature();
                    }}
                    className="text-[#0072BB] project-number flex items-center justify-center gap-[10px] underline focus-visible:outline-0 border border-[#CCCCCC] p-[4px] px-[12px] rounded-[5px]"
                  >
                    <div
                      className={`border-[#0072BB] cursor-pointer h-[20px] w-[20px] border-[2px] rounded-[5px] flex justify-center items-center`}
                    >
                      <RiAddFill size={18} color={"#0072BB"} />
                    </div>
                    <div>{t("addPerson")}</div>
                  </button>
                )}
              </label>
              <div className="w-full flex flex-col gap-[20px]">
                {personSignatures?.length > 0 ? (
                  <div className=" w-[100%] rounded-[10px] border overflow-hidden">
                    {personSignatures?.map((el, index) => {
                      return (
                        <div className="flex justify-between py-[10px] px-[20px] sm:gap-4 gap-2 items-center w-full border-b">
                          <p className="project-number !font-[600]">
                            {el?.name}
                          </p>
                          <p className="project-number !font-[600]">
                            {el?.date}
                          </p>
                          <div className="flex items-center sm:gap-5 gap-2">
                            <img
                              alt={el.name}
                              className="h-[30px]"
                              src={el?.signatureDataUrl}
                            />
                            <button
                              onClick={() => {
                                handleDeleteSignature(el?.name, index);
                              }}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="25"
                                height="24"
                                viewBox="0 0 25 24"
                                fill="none"
                              >
                                <path
                                  d="M4.34545 4.3871L4.42864 4.29289C4.78912 3.93241 5.35635 3.90468 5.74864 4.2097L5.84285 4.29289L12.1357 10.585L18.4286 4.29289C18.8192 3.90237 19.4523 3.90237 19.8428 4.29289C20.2334 4.68342 20.2334 5.31658 19.8428 5.70711L13.5507 12L19.8428 18.2929C20.2033 18.6534 20.2311 19.2206 19.926 19.6129L19.8428 19.7071C19.4824 20.0676 18.9151 20.0953 18.5228 19.7903L18.4286 19.7071L12.1357 13.415L5.84285 19.7071C5.45232 20.0976 4.81916 20.0976 4.42864 19.7071C4.03811 19.3166 4.03811 18.6834 4.42864 18.2929L10.7207 12L4.42864 5.70711C4.06815 5.34662 4.04042 4.77939 4.34545 4.3871L4.42864 4.29289L4.34545 4.3871Z"
                                  fill="#212121"
                                />
                              </svg>
                            </button>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div className="w-[100%] flex justify-between">
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        handleAddPersonSignature();
                      }}
                      className="text-[#0072BB] project-number min-h-[84px] flex flex-col items-center justify-center gap-[10px] underline focus-visible:outline-0 border border-[#CCCCCC] pl-[20px] w-full h-[50px] rounded-[5px]"
                    >
                      <div
                        className={`border-[#0072BB] cursor-pointer h-[20px] w-[20px] border-[2px] rounded-[5px] flex justify-center items-center`}
                      >
                        <RiAddFill size={18} color={"#0072BB"} />
                      </div>
                      <div>{t("addPerson")}</div>
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="my-8">
            <div className="mb-8 overflow-auto">
              {scaffoldData?.length > 0 && (
                <table
                  className="w-full rounded overflow-hidden"
                  style={{ borderCollapse: "collapse" }}
                >
                  <thead className="border-b-2 border-b-[#CCCCCC]">
                    <tr>
                      <th className="sm:p-4 py-2 px-3 sm:text-base text-sm text-left">
                        {t("Subtask")}
                      </th>
                      <th className="sm:p-4 py-2 px-3 sm:text-base text-sm text-left">
                        {t("Risk")}
                      </th>
                      <th className="sm:p-4 py-2 px-3 sm:text-base text-sm text-left">
                        {t("Measure")}
                      </th>
                      <th className="w-14 sm:p-4 py-2 px-3"></th>
                    </tr>
                  </thead>
                  <tbody className="border-b border-b-[#CCCCCC]">
                    {scaffoldData?.map((element, index) => (
                      <React.Fragment key={index}>
                        <tr
                          className={
                            index % 2 === 0
                              ? "border-t border-t-[#CCCCCC]"
                              : "border-t border-t-[#CCCCCC]"
                          }
                        >
                          <td className="sm:p-4 py-2 px-3 sm:text-base text-sm font-medium">
                            {element.subtask}
                          </td>
                          <td className="sm:p-4 py-2 px-3">
                            {element.subtaskData &&
                              element.subtaskData.map((data, dataIndex) => (
                                <ul
                                  className="flex flex-col gap-3"
                                  key={dataIndex}
                                >
                                  <li className="sm:text-base text-sm font-medium flex gap-2">
                                    {data.risk}{" "}
                                    <span className="flex justify-center items-center gap-1 ">
                                      {data?.riskLevel === "low"
                                        ? "🟢"
                                        : data?.riskLevel === "medium"
                                        ? "🟡"
                                        : data?.riskLevel === "high"
                                        ? "🔴"
                                        : ""}{" "}
                                    </span>
                                  </li>
                                </ul>
                              ))}
                          </td>
                          <td className="sm:p-4 py-2 px-3">
                            {element.subtaskData &&
                              element.subtaskData.map((data, dataIndex) => (
                                <ul
                                  className="flex flex-col gap-3"
                                  key={dataIndex}
                                >
                                  <li className="sm:text-base text-sm font-medium">
                                    {data.measure}{" "}
                                    <span>
                                      {data?.measureLevel === "low"
                                        ? "🟢"
                                        : data?.measureLevel === "medium"
                                        ? "🟡"
                                        : data?.riskLevel === "high"
                                        ? "🔴"
                                        : ""}
                                    </span>
                                  </li>
                                </ul>
                              ))}
                          </td>
                          <td className="sm:p-4 py-2 px-3 text-center flex gap-6">
                            <button
                              onClick={(e) => {
                                e.preventDefault();
                                handleEdit(index);
                              }}
                              className="text-[#0072BB] w-4"
                            >
                              <FaPencilAlt color="green" size={20} />
                            </button>
                            <button
                              onClick={(e) => {
                                e.preventDefault();
                                handleDelete(index);
                              }}
                              className="text-[#0072BB] w-4"
                            >
                              <BsTrash3 color="#FF4954" size={20} />
                            </button>
                          </td>
                        </tr>
                      </React.Fragment>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
            <lable className="project-number w-full">{t("addSubtask")}</lable>
            <div className="flex gap-3 mt-2">
              <input
                type="text"
                className="w-32 p-2 border  input-without-icon"
                value={selectedSubTask}
                onChange={handleSubtask}
                onKeyDown={handleKeyDown}
                placeholder={t("addSubtask")}
              />
              <button
                className={`button-text ${
                  selectedSubTask?.length <= 0 ? `bg-[gray]` : `bg-[#0072BB]`
                }
               ${
                 selectedSubTask?.length <= 0
                   ? `hover:bg-[gray]`
                   : `hover:bg-[#0073bbde]`
               } transition-all delay-100 text-[white] px-[20px] py-[10px] rounded-[5px] text-nowrap`}
                onClick={(e) => {
                  e.preventDefault();
                  handelAdd();
                }}
                disabled={selectedSubTask?.length <= 0}
              >
                {t("Add")}
              </button>
            </div>

            {addSubtak && (
              <div>
                {[...Array(divCount)].map((_, index) => (
                  <div
                    className="flex sm:flex-row flex-col justify-between items-center w-full  gap-5 mt-5"
                    key={index}
                  >
                    <div className="flex flex-col justify-start items-start  gap-3  w-full">
                      <label className="project-number">{t("Risk")}</label>
                      <div className="flex justify-center items-center gap-5">
                        <input
                          type="text"
                          className="w-32 p-2 border rounded-md shadow-md input-without-icon"
                          value={data[index]?.risk}
                          onChange={(event) => handleRisk(index, event)}
                          placeholder={t("Risk")}
                          onKeyDown={handleKeyDown}
                        />
                        <div className="relative inline-block w-64">
                          <select
                            onChange={(event) => handleRisk(index, event, true)}
                            className="block appearance-none w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
                          >
                            <option value="">🌟 {t("riskLevel")}</option>
                            <option value="low">🟢 Low</option>
                            <option value="medium">🟡 Medium</option>
                            <option value="high">🔴 High</option>
                          </select>
                          <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                            <svg
                              className="fill-current h-4 w-4"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 20 20"
                            >
                              <path d="M14.348 7.852a.5.5 0 0 0-.697-.716L10 10.788 6.348 7.136a.5.5 0 1 0-.696.717l4 4a.5.5 0 0 0 .696 0l4-4z" />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="flex flex-col justify-start items-start  gap-3  w-full">
                      <label className="project-number">Measures</label>
                      <div className="flex justify-center items-center gap-5">
                        <input
                          type="text"
                          className="w-32 p-2 border rounded-md shadow-md input-without-icon"
                          value={data[index]?.measure}
                          onChange={(event) => handleMeasure(index, event)}
                          placeholder={t("Measure")}
                          onKeyDown={handleKeyDown}
                        />
                        <div className="relative inline-block w-64">
                          <select
                            onChange={(event) =>
                              handleMeasure(index, event, true)
                            }
                            className="block appearance-none w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
                          >
                            <option value="">🌟 {t("riskLevel")}</option>
                            <option value="low">🟢 Low</option>
                            <option value="medium">🟡 Medium</option>
                            <option value="high">🔴 High</option>
                          </select>
                          <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                            <svg
                              className="fill-current h-4 w-4"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 20 20"
                            >
                              <path d="M14.348 7.852a.5.5 0 0 0-.697-.716L10 10.788 6.348 7.136a.5.5 0 1 0-.696.717l4 4a.5.5 0 0 0 .696 0l4-4z" />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
            {addSubtak && (
              <>
                <div>
                  <div className="w-[100%] flex justify-end gap-5 items-center mt-6">
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        handleAddDiv();
                      }}
                      className="text-[#0072BB] project-number flex items-end gap-[10px] underline focus-visible:outline-0"
                    >
                      <div
                        className={`border-[#0072BB] cursor-pointer h-[20px] w-[20px] border-[2px] rounded-[5px] flex justify-center items-center`}
                      >
                        <RiAddFill size={18} color={"#0072BB"} />
                      </div>
                      <div>{t("AddMore")}</div>
                    </button>
                    <button
                      className="button-text bg-[#0072BB] hover:bg-[#0073bbde] transition-all delay-100 text-[white] px-[20px] py-[10px] rounded-[5px]"
                      onClick={(e) => {
                        e.preventDefault();
                        handleSave();
                        handelAdd();
                      }}
                    >
                      {t("Save")}
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>

          <div className="w-full text-center">
            <button
              onClick={(e) => {
                e.preventDefault();
                setExtendedList(!extendedList);
              }}
              className="font-bold text-sm px-4 py-2 rounded-lg bg-[#0081c8] text-white mb-5 "
            >
              {t("extendedList")}
            </button>
          </div>

          <div
            className={`transition-all duration-500 ease-in-out overflow-hidden ${
              extendedList ? "max-h-0 opacity-0" : "opacity-100"
            }`}
          >
            <div className="sm:p-10 mt-10 border-t-2">
              <SafetyChecklist setItems={setItems} items={items} />
            </div>

            <div className="sm:p-10 mt-10 border-t-2">
              <RequiredPermitChecklist
                setRequiredPermit={setRequiredPermit}
                requiredPermit={requiredPermit}
              />
            </div>

            <div className="sm:p-10 mt-10 border-t-2 border-b-2">
              <DesignatedWorkChecklist
                setDesignatedWorkArea={setDesignatedWorkArea}
                designatedWorkArea={designatedWorkArea}
              />
            </div>

            <div className="w-full lg:w-[calc(50%-20px)] flex flex-col gap-[6px] mt-10">
              <lable className="project-number w-full">
                {t("emergencyProcedure")}
              </lable>
              <div className="">
                <textarea
                  className="w-full p-[20px] border rounded-[5px]"
                  type="text"
                  placeholder={t("emergencyProcedure")}
                  {...register("emergencyProcedure", {})}
                />
              </div>
            </div>
          </div>

          <div className="flex flex-col sm:gap-[30px] gap-4 sm:mt-[60px] mt-10">
            <div className="flex justify-between items-center">
              <p className="medium-title">{t("signature")}</p>
            </div>
            <div className="flex flex-col lg:flex-row sm:gap-[50px] gap-6 justify-around items-center">
              <div className="flex flex-col sm:gap-[20px] gap-3 w-full lg:w-[380px] items-center">
                {signatureImage ? (
                  <>
                    <img
                      className="m-auto"
                      width={169}
                      src={signatureImage}
                      alt="Signature"
                    />
                    <p className="text-black  text-[cap] font-Montserrat font-bold text-base leading-7">
                      {_.startCase(_.toLower(customerName))}
                    </p>
                  </>
                ) : (
                  ""
                )}
                {signatureImage ? (
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      setSignatureImage(null);
                    }}
                  >
                    {t("clearSignature")}
                  </button>
                ) : (
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      handleAddSignature();
                    }}
                    className="sigbtn"
                  >
                    <img src="/addShape.svg" alt="sign-add" />
                    {t("AddSignature")}{" "}
                  </button>
                )}
                <div className="w-full border"></div>
                <p>{t("customer’sSignature")} </p>
              </div>
              <div className="flex flex-col sm:gap-[20px] gap-3 w-full lg:w-[380px] items-center">
                <div className="w-full flex gap-[20px] flex-col items-center">
                  {signatureImageone ? (
                    <>
                      <img
                        className="m-auto"
                        width={169}
                        src={signatureImageone}
                        alt="Signature"
                      />
                      <p className="text-black  text-[cap] font-Montserrat font-bold text-base leading-7">
                        {_.startCase(_.toLower(approverName))}
                      </p>
                    </>
                  ) : (
                    ""
                  )}
                  {signatureImageone ? (
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        setSignatureImageone(null);
                      }}
                    >
                      {t("clearSignature")}
                    </button>
                  ) : (
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        handleAddSignatureone();
                      }}
                      className="sigbtn"
                    >
                      <img src="/addShape.svg" alt="sign-add" />
                      {t("AddSignature")}
                    </button>
                  )}
                </div>
                <div className="w-full border"></div>
                <p>
                  {" "}
                  {t("TeamleaderSignature")}{" "}
                  <span style={{ color: "red", fontSize: "1.5em" }}>*</span>
                </p>
              </div>
            </div>
            <SignatureModal
              isOpen={isModalOpen}
              onClose={closeModal}
              onSave={handleSaveSignature}
            />
            <SignaturePersonModal
              isOpen={isPersonModalOpen}
              onClose={closeModal}
              onSave={handlePersonSaveSignature}
            />
            <SignatureModal
              isOpen={isModalOpenone}
              onClose={closeModalone}
              onSave={handleSaveSignatureone}
            />
          </div>

          <div className="text-center md:mt-[100px] sm:mt-12 mt-6">
            <button
              type="submit"
              className="button-text bg-[#0072BB] px-[20px] py-[10px] rounded-[5px] text-white"
            >
              {isLoading ? t("loading") : t("save")}
            </button>
          </div>
        </div>
      </form>

      {showConfirmationModal && (
        <div className="fixed inset-0 flex justify-center items-center bg-black bg-opacity-80  z-40 ">
          <div className="relative sm:w-[600px] w-auto  min-h-[600px] h-auto bg-slate-100 rounded-md mx-2 ">
            <IoClose
              onClick={() => setShowConfirmationModal(false)}
              className="absolute top-[3%] right-[2%] text-[26px] cursor-pointer rounded-full border-2 font-bold"
            />
            <button
              onClick={() => setShowConfirmationModal(false)}
              className="absolute top-[1%] left-[2%] text-sm font-bold bg-blue-500 text-white py-2 px-3 rounded-md  border  cursor-pointer mt-5 "
            >
              Go Back
            </button>

            <div class="relative overflow-x-auto sm:rounded-lg mt-20 px-2">
              <table class="w-full text-sm text-left rtl:text-right ">
                <thead class="text-xs text-gray-700 uppercase ">
                  <tr>
                    <th scope="col" class="px-6 py-3">
                      Risk
                    </th>
                    <th scope="col" class="px-6 py-3">
                      Measure
                    </th>
                    <th scope="col" class="px-6 py-3">
                      Delete
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {editedData.map((ele, id) => (
                    <tr class="bg-white border-b   ">
                      <th scope="row" class="px-6 py-4 font-medium ">
                        {ele.risk}{" "}
                        <span>
                          {ele?.riskLevel === "low"
                            ? "🟢"
                            : ele?.riskLevel === "medium"
                            ? "🟡"
                            : ele?.riskLevel === "high"
                            ? "🔴"
                            : ""}
                        </span>
                      </th>
                      <td class="px-6 py-4">
                        {ele.measure}{" "}
                        <span>
                          {ele?.measureLevel === "low"
                            ? "🟢"
                            : ele?.measureLevel === "medium"
                            ? "🟡"
                            : ele?.measureLevel === "high"
                            ? "🔴"
                            : ""}
                        </span>
                      </td>
                      <td class="px-6 py-4">
                        <button
                          onClick={(e) => {
                            e.preventDefault();
                            handleEditTaskDelete(id);
                          }}
                          className="text-[#0072BB] w-4"
                        >
                          <BsTrash3 color="#FF4954" size={20} />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <div className=" mt-10">
                <div className=" ">
                  <div className="flex items-center justify-between gap-5">
                    <div>
                      <label className="font-bold text-sm">{t("Risk")}</label>
                      <input
                        type="text"
                        className=" !h-10 p-2  rounded-md shadow-md input-without-icon"
                        value={editCreateTask.risk}
                        onChange={(e) =>
                          setEditCreateTask({
                            ...editCreateTask,
                            risk: e.target.value,
                          })
                        }
                        placeholder={t("Risk")}
                        onKeyDown={handleKeyDown}
                      />
                    </div>

                    <div className=" ">
                      <div className="font-bold text-sm">{t("addSubtask")}</div>
                      <select
                        value={editCreateTask.riskLevel}
                        onChange={(e) =>
                          setEditCreateTask({
                            ...editCreateTask,
                            riskLevel: e.target.value,
                          })
                        }
                        className="block appearance-none w-full bg-white  border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
                      >
                        <option value="">🌟 {t("riskLevel")}</option>
                        <option value="low">🟢 Low</option>
                        <option value="medium">🟡 Medium</option>
                        <option value="high">🔴 High</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div className="flex items-center justify-between gap-5">
                  <div>
                    <label className="font-bold text-sm">Measure</label>
                    <input
                      type="text"
                      className=" !h-10 p-2  rounded-md shadow-md input-without-icon"
                      value={editCreateTask.measure}
                      onChange={(e) =>
                        setEditCreateTask({
                          ...editCreateTask,
                          measure: e.target.value,
                        })
                      }
                      placeholder={t("Measure")}
                      onKeyDown={handleKeyDown}
                    />
                  </div>
                  <div className="">
                    <div className="font-bold text-sm">Measure Level</div>
                    <select
                      value={editCreateTask.measureLevel}
                      onChange={(e) =>
                        setEditCreateTask({
                          ...editCreateTask,
                          measureLevel: e.target.value,
                        })
                      }
                      className="block appearance-none w-full bg-white  border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
                    >
                      <option value="">🌟 {t("riskLevel")}</option>
                      <option value="low">🟢 Low</option>
                      <option value="medium">🟡 Medium</option>
                      <option value="high">🔴 High</option>
                    </select>
                  </div>
                </div>
                <div className="flex justify-between">
                  <button
                    onClick={() => handleEditTask()}
                    className="mt-2 font-bold text-white bg-[#0081c8] rounded-lg py-2 px-4"
                  >
                    {t("add")}
                  </button>
                  <button
                    onClick={() => handleEditMainTask()}
                    className="mt-2 font-bold text-white bg-[#0081c8] rounded-lg py-2 px-4"
                  >
                    Edit Task
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {isProjectOpen && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4 transition-opacity duration-300 ease-in-out">
          <div className="bg-white rounded-2xl shadow-xl p-8 w-full max-w-md mx-4 transform transition-all duration-300 ease-out scale-100 opacity-100">
            <h2 className="text-2xl font-bold mb-6 text-center text-gray-800">
              Select Project for New Approval Form
            </h2>

            {/* Search input */}
            <div className="relative mb-4">
              <input
                type="text"
                placeholder="Search by project name or number..."
                className="w-full bg-gray-50 border border-gray-300 rounded-xl p-3 pl-10 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none text-gray-500">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
              {searchTerm && (
                <button
                  className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-500 hover:text-gray-700"
                  onClick={() => setSearchTerm("")}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                      clipRule="evenodd"
                    />
                  </svg>
                </button>
              )}
            </div>

            {projects.length === 0 ? (
              <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded-xl text-red-700 text-center">
                <div className="flex items-center justify-center mb-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5 mr-2"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span className="font-semibold">No Projects Available</span>
                </div>
                <p className="text-sm">
                  Please create a new project to continue.
                </p>
              </div>
            ) : filteredProjects.length === 0 ? (
              <div className="mb-6 p-4 bg-yellow-50 border border-yellow-200 rounded-xl text-yellow-700 text-center">
                <div className="flex items-center justify-center mb-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5 mr-2"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span className="font-semibold">No Matching Projects</span>
                </div>
                <p className="text-sm">
                  No projects match your search. Try different keywords.
                </p>
              </div>
            ) : (
              <div className="max-h-60 overflow-y-auto mb-6 bg-gray-50 border border-gray-300 rounded-xl">
                {filteredProjects.map((project) => (
                  <div
                    key={project._id}
                    className={`p-3 border-b border-gray-200 last:border-b-0 cursor-pointer hover:bg-blue-50 transition-colors duration-200 ${
                      projectId === project._id ? "bg-blue-100" : ""
                    }`}
                    onClick={() => setProjectId(project._id)}
                  >
                    <div className="flex items-center">
                      <div className="flex-1">
                        <div className="font-medium text-gray-800">
                          {project.projectName}
                        </div>
                        <div className="text-sm text-gray-600">
                          #{project.projectNumber}
                        </div>
                      </div>
                      {projectId === project._id && (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-5 w-5 text-blue-600"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fillRule="evenodd"
                            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                            clipRule="evenodd"
                          />
                        </svg>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )}

            <div className="flex items-center space-x-2 my-6">
              <div className="flex-1 border-t border-gray-200"></div>
              <span className="text-xs font-medium text-gray-500 px-3 bg-white">
                OR
              </span>
              <div className="flex-1 border-t border-gray-200"></div>
            </div>

            <Link to="/admin/project/create-new-project" className="block mb-6">
              <button className="w-full flex items-center justify-center gap-2 py-3 px-4 border-2 border-dashed border-gray-300 rounded-xl text-gray-700 hover:bg-gray-50 hover:border-blue-400 hover:text-blue-600 transition-all duration-200 font-medium">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
                    clipRule="evenodd"
                  />
                </svg>
                Create New Project
              </button>
            </Link>

            <div className="grid grid-cols-2 gap-4 mt-6">
              <button
                onClick={handleGoBack}
                className="w-full bg-white border border-gray-300 text-gray-700 font-medium py-3 px-4 rounded-xl hover:bg-gray-50 hover:border-gray-400 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-gray-300"
              >
                Back
              </button>
              <button
                onClick={handleConfirm}
                className={`w-full font-medium py-3 px-4 rounded-xl transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                  !projectId && filteredProjects.length > 0
                    ? "bg-blue-400 text-white cursor-not-allowed opacity-70"
                    : "bg-blue-600 text-white hover:bg-blue-700 shadow-md hover:shadow-lg"
                }`}
                disabled={!projectId && filteredProjects.length > 0}
              >
                Continue
              </button>
            </div>
          </div>
        </div>
      )}
    </MainLayout>
  );
};

export default SafeJobAnalysisPage;
